import Link from "next/link"
import React from "react"
import CustomButton from "../../../../ui/atoms/Button"
import Typography from "../../../../ui/atoms/Typography"
import { CustomCol, CustomRow } from "../../../../ui/spacings"
import { toItaDate } from "../../../../utils/dates"
import { CompletedOrder } from "../../types"
import { getMaxRefoundDate } from "../../utils/returns"
import ReturnForm from "../ReturnForm"

interface Props {
  order: CompletedOrder
}

const ReturnPanel = ({ order }: Props) => {
  const [showForm, setShowForm] = React.useState(false)
  return (
    <>
      <Typography variant="subtitle2">
        Hai un problema con il tuo ordine?
      </Typography>
      <Typography variant="body1">
        {`Puoi effettuare gratuitamente un reso online o nei nostri negozi. Hai tempo fino a ${toItaDate(
          getMaxRefoundDate(order) as Date
        )}`}
      </Typography>
      <CustomRow justify="center" className="my-6">
        <CustomCol xs={12} sm={6} className="text-center">
          <CustomButton variant="text" onClick={() => setShowForm(true)}>
            Crea reso
          </CustomButton>
        </CustomCol>
        <CustomCol xs={12} sm={6} className="text-center">
          <Link href="/i-nostri-negozi" passHref>
            <a>
              <CustomButton variant="text">Trova negozio</CustomButton>
            </a>
          </Link>
        </CustomCol>
      </CustomRow>
      {showForm && (
        <div className="mt-6">
          <ReturnForm order={order} />
        </div>
      )}
    </>
  )
}

export default ReturnPanel
